import { useCallback, useEffect, useState } from "react";
import { useLang } from "../../context/langProvider";
import { useNavigate, useLocation } from "react-router-dom";
import "./styles.css";
import { faRotateLeft, faRotateRight, faStop } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormModalProjetClient from "../FormModalProjetClient";

export default function ListMainServices() {
  const [secteurs, setSecteurs] = useState([]);
  const [scrollClass, setScrollClass] = useState("cards-secteurs-container");
  const [showFormProjet, setShowFormProjet] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(false);
  const { lang } = useLang();
  const navigate = useNavigate();
  const location = useLocation();

  const refreshSecteurs = useCallback(() => {
    setLoading(true);
    fetch(`${apiUrl}/api/secteurs`)
      .then((res) => res.json())
      .then((data) => setSecteurs(data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [apiUrl, lang]);

  useEffect(() => {
    refreshSecteurs();
  }, [refreshSecteurs]);

  return (
    <>
    <div style={{display:"flex", alignItems:"center",padding:"15px"}}>
      <div style={{width:"40%",height:"1px",border:"1px solid grey"}}></div>
      <div style={{width:"20%",textAlign:"center"}}>OU</div>
      <div style={{width:"40%",height:"1px",border:"1px solid grey"}}></div>

    </div>
    <div className="listMainSecteurs">
      {loading ? (
        <div className="loader">
          <div className="spinner"></div>
          Chargement des secteurs...
        </div>
      ) : (
        <>

          <div className={scrollClass}>
            {secteurs.concat(secteurs).map((secteur, index) => {
              const isPrestataire = location.pathname.startsWith(
                "/espace-prestataire"
              );
              const targetUrl = isPrestataire
                ? `/espace-prestataire/${secteur.slugSecteur}`
                : `/${secteur.slugSecteur}`;

              return (
                <div key={index} className="card-container">
                  <div
                    onClick={() => navigate(targetUrl)}
                    className="card-secteur"
                  >
                    <img
                      src={`${apiUrl}/api/files/?categorie=secteurs&file=${secteur.iconSecteur}`}
                      alt="icone secteur"
                    />
                    <span>{secteur.labelSecteur}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
    <div className="controls">
            <button
              className="control-btn"
              onClick={() => setScrollClass("cards-secteurs-container")}
            >
              <FontAwesomeIcon icon={faRotateLeft} />
            </button>
            <button
              className="control-btn"
              onClick={() => setScrollClass("cards-secteurs-container-manual")}
            >
              <FontAwesomeIcon icon={faStop} />
            </button>
            <button
              className="control-btn"
              onClick={() => setScrollClass("cards-secteurs-container-reverse")}
            >
              <FontAwesomeIcon icon={faRotateRight} />
            </button>
          </div>
          {
            showFormProjet&&(
              <FormModalProjetClient onClose={()=>setShowFormProjet(false)}/>
            )
          }

    </>
  );
}
